import { render } from "./SimbolosJaulas.vue?vue&type=template&id=2787de26"
const script = {}

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__